<form [formGroup]="formGroupStep" *ngIf="formGroupStep && formVariant">
  <div *ngFor="let sequence of formGroupStep?.controls?.sequences?.value; index as i">
    <div class="program-title">
      {{ applianceText(sequence.applianceGroup) }}
    </div>
    <div *ngIf="sequence.applianceGroup === defaultApplianceGroup">({{ 'DEFAULT' | translate }})</div>
    <mat-table [dataSource]="dataSource[i].data" *ngIf="dataSource[i]" class="space-t-s cell-margin-none">
      <ng-container matColumnDef="program">
        <mat-header-cell *matHeaderCellDef class="max-width: 400px; custom-mat-header-cell-program">Programme</mat-header-cell>
        <mat-cell *matCellDef="let element" class="custom-mat-cell-program">
          <mat-form-field class="form-field-m form-field-dropdown custom-form-field-program" appearance="fill">
            <mat-label> {{ 'CHOOSE_A_PROGRAM' | translate }} </mat-label>
            <mat-select
              id="RecipesModifyStepsStepProgramSelectBtn"
              [(ngModel)]="element.program"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="changeProgram(element); markAsDirty()"
              [disabled]="programList?.length === 0"
            >
              <div id="RecipesModifyStepsStepProgramLst">
                <mat-option *ngFor="let prog of filterProgram(sequence.applianceGroup)" [value]="prog.key">
                  {{ prog.translatedName }}
                </mat-option>
              </div>
            </mat-select>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="DURATION">
        <mat-header-cell *matHeaderCellDef class="custom-mat-header-cell-program">{{ getName('DURATION', psNamesList) }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="custom-mat-cell-program">
          <ng-container *ngIf="element.parameters && getParameterIndexByCommonKey(element.parameters, 'DURATION') > -1">
            <mat-form-field
              appearance="fill"
              [ngClass]="{ 'mat-error': getParameter(element, 'DURATION').error }"
              class="custom-form-field-program"
            >
              <input
                matInput
                type="text"
                [mask]="timeMask"
                [patterns]="timePatterns"
                [specialCharacters]="specialCharacters"
                [dropSpecialCharacters]="false"
                [keepCharacterPositions]="true"
                (change)="changeTime(getParameter(element, 'DURATION'))"
                [(ngModel)]="getParameter(element, 'DURATION').valueTemp"
                [ngModelOptions]="{ standalone: true }"
              />
              <mat-hint class="mat-error" *ngIf="getParameter(element, 'DURATION').error === 'bottomValue'">
                {{
                  'ERRORS_PARAMETER_GREATER_THAN'
                    | translate
                    | replace : '{{ bottomValue \\}\\}' : convertTimeToText(getParameter(element, 'DURATION').bottomValue)
                }}
              </mat-hint>
              <mat-hint class="mat-error" *ngIf="getParameter(element, 'DURATION').error === 'topValue'">
                {{
                  'ERRORS_PARAMETER_LOWER_THAN'
                    | translate
                    | replace : '{{ topValue \\}\\}' : convertTimeToText(getParameter(element, 'DURATION').topValue)
                }}
              </mat-hint>
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="COUNTDOWN">
        <mat-header-cell *matHeaderCellDef class="custom-mat-header-cell-program">{{ getName('COUNTDOWN', psNamesList) }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="custom-mat-cell-program">
          <ng-container *ngIf="element.parameters && getParameterIndexByCommonKey(element.parameters, 'COUNTDOWN') > -1">
            <mat-form-field
              class="custom-form-field-program"
              appearance="fill"
              [ngClass]="{ 'mat-error': getParameter(element, 'COUNTDOWN').error }"
            >
              <input
                matInput
                type="text"
                [mask]="timeMask"
                [patterns]="timePatterns"
                [specialCharacters]="specialCharacters"
                [dropSpecialCharacters]="false"
                [keepCharacterPositions]="true"
                (change)="changeTime(getParameter(element, 'COUNTDOWN'))"
                [(ngModel)]="getParameter(element, 'COUNTDOWN').valueTemp"
                [ngModelOptions]="{ standalone: true }"
              />
              <mat-hint class="mat-error" *ngIf="getParameter(element, 'COUNTDOWN').error === 'bottomValue'">
                {{
                  'ERRORS_PARAMETER_GREATER_THAN'
                    | translate
                    | replace : '{{ bottomValue \\}\\}' : convertTimeToText(getParameter(element, 'DURATION').bottomValue)
                }}
              </mat-hint>
              <mat-hint class="mat-error" *ngIf="getParameter(element, 'COUNTDOWN').error === 'topValue'">
                {{
                  'ERRORS_PARAMETER_LOWER_THAN'
                    | translate
                    | replace : '{{ topValue \\}\\}' : convertTimeToText(getParameter(element, 'DURATION').topValue)
                }}
              </mat-hint>
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="SPEED">
        <mat-header-cell *matHeaderCellDef class="custom-mat-header-cell-program">{{ getName('SPEED', psNamesList) }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="custom-mat-cell-program">
          <ng-container *ngIf="element.parameters && getParameterIndexByCommonKey(element.parameters, 'SPEED') > -1">
            <mat-form-field class="form-field-s form-field-dropdown custom-form-field-program" appearance="fill">
              <mat-select
                [(ngModel)]="getParameter(element, 'SPEED').value"
                (ngModelChange)="markAsDirty()"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="programList?.length === 0"
              >
                <mat-option
                  *ngFor="let setting of getParameterSettingByKey(getParameter(element, 'SPEED').key)?.possibleValues"
                  [value]="setting.key"
                >
                  {{ setting.key }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="TEMPERATURE">
        <mat-header-cell *matHeaderCellDef class="custom-mat-header-cell-program">{{
          getName('TEMPERATURE', psNamesList)
        }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="custom-mat-cell-program">
          <ng-container *ngIf="element.parameters && getParameterIndexByCommonKey(element.parameters, 'TEMPERATURE') > -1">
            <mat-form-field
              class="custom-form-field-program"
              appearance="fill"
              [ngClass]="{ 'mat-error': getParameter(element, 'TEMPERATURE').error }"
            >
              <input
                matInput
                type="number"
                [(ngModel)]="getParameter(element, 'TEMPERATURE').value"
                [ngModelOptions]="{ standalone: true }"
                (change)="checkErrorField(getParameter(element, 'TEMPERATURE')); markAsDirty()"
              />
              <mat-hint class="mat-error" *ngIf="getParameter(element, 'TEMPERATURE').error === 'NaN'">
                {{ 'ERRORS_PARAMETER_NOT_INT' | translate }}
              </mat-hint>
              <mat-hint class="mat-error" *ngIf="getParameter(element, 'TEMPERATURE').error === 'bottomValue'">
                {{
                  'ERRORS_PARAMETER_GREATER_THAN'
                    | translate
                    | replace : '{{ bottomValue \\}\\}' : '' + getParameter(element, 'TEMPERATURE').bottomValue
                }}
              </mat-hint>
              <mat-hint class="mat-error" *ngIf="getParameter(element, 'TEMPERATURE').error === 'topValue'">
                {{
                  'ERRORS_PARAMETER_LOWER_THAN'
                    | translate
                    | replace : '{{ topValue \\}\\}' : '' + getParameter(element, 'TEMPERATURE').topValue
                }}
              </mat-hint>
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="KEEP_WARM">
        <mat-header-cell *matHeaderCellDef class="custom-mat-header-cell-program">{{ getName('KEEP_WARM', psNamesList) }}</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <ng-container *ngIf="element.parameters && getParameterIndexByCommonKey(element.parameters, 'KEEP_WARM') > -1">
            <mat-form-field class="form-field-s custom-form-field-program" appearance="fill">
              <mat-select
                [(ngModel)]="getParameter(element, 'KEEP_WARM').value"
                (ngModelChange)="markAsDirty()"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="programList?.length === 0"
              >
                <mat-option
                  *ngFor="let setting of getParameterSettingByKey(getParameter(element, 'KEEP_WARM').key)?.possibleValues"
                  [value]="setting.key"
                >
                  {{ setting.key }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="ALERT_TEXT">
        <mat-header-cell *matHeaderCellDef class="custom-mat-header-cell-program">{{ getName('ALERT_TEXT', psNamesList) }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="custom-mat-cell-program">
          <ng-container *ngIf="element.parameters && getParameterIndexByCommonKey(element.parameters, 'ALERT_TEXT') > -1">
            <mat-form-field class="custom-form-field-program" appearance="fill">
              <input
                matInput
                [(ngModel)]="getParameter(element, 'ALERT_TEXT').value"
                (change)="markAsDirty()"
                [ngModelOptions]="{ standalone: true }"
              />
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="ALERT_TYPE">
        <mat-header-cell *matHeaderCellDef class="custom-mat-header-cell-program">{{ getName('ALERT_TYPE', psNamesList) }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="custom-mat-cell-program">
          <ng-container *ngIf="element.parameters && getParameterIndexByCommonKey(element.parameters, 'ALERT_TYPE') > -1">
            <mat-form-field class="form-field-s form-field-dropdown custom-form-field-program" appearance="fill">
              <mat-select
                [(ngModel)]="getParameter(element, 'ALERT_TYPE').value"
                (ngModelChange)="markAsDirty()"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="programList?.length === 0"
              >
                <mat-option
                  *ngFor="let setting of getParameterSettingByKey(getParameter(element, 'ALERT_TYPE').key)?.possibleValues"
                  [value]="setting.key"
                >
                  {{ setting.key }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="INGREDIENT">
        <mat-header-cell *matHeaderCellDef class="custom-mat-header-cell-program">{{ getName('INGREDIENT', psNamesList) }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="custom-mat-cell-program">
          <ng-container *ngIf="element.parameters && getParameterIndexByCommonKey(element.parameters, 'INGREDIENT') > -1">
            <mat-form-field class="form-field-s form-field-dropdown custom-form-field-program" appearance="fill">
              <mat-select
                [(ngModel)]="getParameter(element, 'INGREDIENT').value"
                (ngModelChange)="markAsDirty()"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="programList?.length === 0"
              >
                <mat-option *ngFor="let ingredientID of getIngredientIDList()" [value]="ingredientID.topIngredientFid">
                  {{ getIngredientName(ingredientID.topIngredientFid) }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </mat-cell>
      </ng-container>
      <ng-container *ngFor="let dropdown of dropDowns[i]">
        <ng-container [matColumnDef]="dropdown.key">
          <mat-header-cell *matHeaderCellDef class="custom-mat-header-cell-program">{{
            getGenericName(dropdown.value.name.key, psNamesList)
          }}</mat-header-cell>
          <mat-cell *matCellDef="let element" class="custom-mat-cell-program">
            <ng-container
              *ngIf="element.parameters && getGenericParameterIndexByCommonKey(element.parameters, dropdown.value.name.key) > -1"
            >
              <mat-form-field class="form-field-s form-field-dropdown custom-form-field-program" appearance="fill">
                <mat-select
                  [(ngModel)]="getGenericParameter(element, dropdown.value.name.key).value"
                  (ngModelChange)="markAsDirty()"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="programList?.length === 0"
                >
                  <mat-option
                    *ngFor="
                      let setting of getGenericParameterSettingByKey(getGenericParameter(element, dropdown.value.name.key).key)
                        ?.possibleValues
                    "
                    [value]="setting.key"
                  >
                    {{ setting.key }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </mat-cell>
        </ng-container>
      </ng-container>
      <ng-container matColumnDef="NUMERIC">
        <mat-header-cell *matHeaderCellDef class="custom-mat-header-cell-program">NUMERIC</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field class="custom-form-field-program" appearance="fill">
            <mat-label>{{ element.name }}</mat-label>
            <input
              matInput
              type="number"
              [min]="element.minValue"
              [max]="element.maxValue"
              [(ngModel)]="getParameter(element, 'NUMERIC').value"
              (change)="markAsDirty()"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="UNLOCKED">
        <mat-header-cell *matHeaderCellDef class="custom-mat-header-cell-program">UNLOCKED</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-form-field class="custom-form-field-program" appearance="fill">
            <mat-label>{{ element.name }}</mat-label>
            <input
              matInput
              [(ngModel)]="getParameter(element, 'UNLOCKED').value"
              (change)="markAsDirty()"
              [ngModelOptions]="{ standalone: true }"
            />
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef class="custom-mat-header-cell-program"></mat-header-cell>
        <mat-cell *matCellDef="let element" class="custom-mat-cell-program">
          <button mat-button class="btn delete-button" (click)="removeOperationFromSequence(i, element)">
            <i class="fas fa-trash" aria-hidden="true"></i>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="dataSource[i].columns || ['program']"></mat-header-row>
      <mat-row *matRowDef="let row; columns: dataSource[i].columns || ['program']"></mat-row>
    </mat-table>
    <button mat-button (click)="addEmptyOperationToSequence(i)" class="add-button-program">
      {{ 'ADD_A_PROGRAM' | translate }}
      <mat-icon
        aria-hidden="false"
        aria-label="Add button"
        [id]="'RecipesModifyStepsAddProgramBtn' + getSanitizedId(applianceText(sequence.applianceGroup) || '')"
        >add</mat-icon
      >
    </button>
  </div>
</form>
